@if (isPopupVisible) {
  <dx-popup
    contentTemplate="popup-content"
    [(visible)]="isPopupVisible"
    title="Create Workload"
    position="center"
    [hideOnOutsideClick]="false"
    [showTitle]="true"
    [height]="700"
    [width]="650"
    [resizeEnabled]="false"
    [dragEnabled]="false"
    (onHidden)="onCloseModal()"
    (onShowing)="preparePE()"
  >
    <div *dxTemplate="let data of 'popup-content'">
      <form [formGroup]="workloadForm" class="form-layout">
        <dx-autocomplete
          name="projectEngineer"
          formControlName="projectEngineer"
          placeholder="Search for a project engineer..."
          [dataSource]="projectEngOptions"
          label="PE/TC"
          labelMode="outside"
          valueExpr="name"
          [showClearButton]="true"
          (onSelectionChanged)="onSelectionChanged($event)"
        >
        </dx-autocomplete>
        <ng-container
          *ngIf="workloadForm.controls['projectEngineer'] as projectEngineer"
        >
          <span
            class="input-error"
            *ngIf="
              projectEngineer.dirty && projectEngineer.hasError('required')
            "
          >
            This field is required
          </span>
        </ng-container>
        <dx-text-box
          name="workloadName"
          formControlName="workloadName"
          label="Workload Name"
          labelMode="outside"
        >
        </dx-text-box>
        <ng-container
          *ngIf="workloadForm.controls['workloadName'] as workloadName"
        >
          <span
            class="input-error"
            *ngIf="workloadName.dirty && workloadName.hasError('required')"
          >
            This field is required
          </span>
        </ng-container>
        <dx-text-box
          name="customer"
          formControlName="customer"
          label="Customer"
          labelMode="outside"
        >
        </dx-text-box>
        <ng-container *ngIf="workloadForm.controls['customer'] as customer">
          <span
            class="input-error"
            *ngIf="customer.dirty && customer.hasError('required')"
          >
            This field is required
          </span>
        </ng-container>
        <dx-date-box
          type="date"
          label="Start date"
          labelMode="outside"
          name="startDate"
          formControlName="startDate"
          [inputAttr]="{ 'aria-label': 'Date' }"
          [displayFormat]="'x' | calendarDate"
        >
        </dx-date-box>
        <ng-container *ngIf="workloadForm.controls['startDate'] as startDate">
          <span
            class="input-error"
            *ngIf="startDate.dirty && startDate.hasError('required')"
          >
            This field is required
          </span>
        </ng-container>
        <dx-date-box
          type="date"
          label="End date"
          labelMode="outside"
          name="endDate"
          formControlName="endDate"
          [inputAttr]="{ 'aria-label': 'Date' }"
          [displayFormat]="'x' | calendarDate"
        >
        </dx-date-box>
        <ng-container *ngIf="workloadForm.controls['endDate'] as endDate">
          <span
            class="input-error"
            *ngIf="endDate.dirty && endDate.hasError('required')"
          >
            This field is required
          </span>
        </ng-container>
        <dx-select-box
          [dataSource]="winProbOptions"
          label="Win probability (%)"
          labelMode="outside"
          name="winProbability"
          formControlName="winProbability"
        >
        </dx-select-box>
        <ng-container
          *ngIf="workloadForm.controls['winProbability'] as winProbability"
        >
          <span
            class="input-error"
            *ngIf="winProbability.dirty && winProbability.hasError('required')"
          >
            This field is required
          </span>
        </ng-container>
        <dx-select-box
          [dataSource]="clmOptions"
          label="CLM"
          labelMode="outside"
          name="clm"
          formControlName="clm"
        >
        </dx-select-box>
        <ng-container *ngIf="workloadForm.controls['clm'] as clm">
          <span
            class="input-error"
            *ngIf="clm.dirty && clm.hasError('required')"
          >
            This field is required
          </span>
        </ng-container>
      </form>
      @if (errorsArray.length > 0) {
        <div style="margin-top: 0.5rem">
          @for (error of errorsArray; track $index) {
            <div class="input-error">{{ error.reason }}</div>
          }
        </div>
      }
    </div>
    <dxi-toolbar-item
      widget="dxButton"
      toolbar="bottom"
      location="after"
      [options]="closeButtonOptions"
    >
    </dxi-toolbar-item>
    <dxi-toolbar-item
      widget="dxButton"
      toolbar="bottom"
      location="after"
      [options]="saveButtonOptions"
      [disabled]="!workloadForm.valid"
    >
    </dxi-toolbar-item>
  </dx-popup>
}
